import * as dd from "dingtalk-jsapi";

export default function getDdCode() {
  return new Promise((resolve) => {
    const isDev = localStorage.getItem("liupl");
    if (dd.env.platform === "notInDingTalk" && isDev) {
      // 我的开发环境
      resolve({
        code: "32fevevewvewf",
      });
    } else {
      dd.ready(() => {
        // dd.ready参数为回调函数，在环境准备就绪时触发，jsapi的调用需要保证在该回调函数触发后调用，否则无效。
        dd.runtime.permission.requestAuthCode({
          corpId: "ding2392b0260c57e24f35c2f4657eb6378f",
          onSuccess: (result) => {
            /*{
                          code: 'hYLK98jkf0m' //string authCode
                        }*/
            resolve(result);
          },
          onFail: function () {
            // reject(err)
          },
        });
      });
    }
  });
}
